import ApiService from './api.service'

const WholeSaleReportService = {

		/**
		 * Get daily sum
		 * @param data
		 * @returns {*}
		 */
		daily: function (data) {
			return ApiService.post(`/sale/sale-daily-sum`, data)
		},

		/**
		 * Get monthly sum
		 * @param data
		 * @returns {*}
		 */
		monthly: function (data) {
			return ApiService.post(`/sale/sale-month-sum`, data)
		},
		searchReport: function (data) {
			if (data.sale == 'sale') {
				return ApiService.post(`/report/wholesale`, data)
			} else if (data.sale == 'spos') {
				return ApiService.post(`/report/wh-sponsorship`, data)
			} else if (data.sale == 'QARZGA') {
				return ApiService.post(`/report/for-whdebt`, data)
			} else {
				return ApiService.post(`/report/wh-employee`, data)
			}
		},

		// reportCategoryForMonitoring(data) {
		// 	return ApiService.post(`/report/category`, data)
		// },
		// reportMonitoringForDiogram(data) {
		// 	return ApiService.post(`/report/get-revenue-list-by-month`, data)
		// },
		/**
		 * Get sum in date range
		 * @returns {*}
		 */
		inDateRange:

			function (data) {
				return ApiService.post(`/sale/from-to-sum`, data)
			}

		,

		/**
		 * Get sum by Employee
		 * @returns {*}
		 */
		getByEmployee: function (id) {
			return ApiService.get(`/sale/all-sum-with-employee/${id}`)
		}
		,

		getPaymentTypeCard: function () {
			return ApiService.post(`/sale/get-payment`)
		},

		getCheckByKeyword(keywords) {
			return ApiService.get(`/sale/wh-search/${keywords}`)
		},

		finishReturn(data) {
			return ApiService.post(`/sale/finish-return-wh`, data)
		}


	}
;

export default WholeSaleReportService;
